export const getFileType = (fileUrl: string): 'pdf' | 'image' | 'unknown' => {
  const extension = fileUrl.split('.').pop()?.toLowerCase();

  if (!extension) return 'unknown';

  if (extension === 'pdf') return 'pdf';

  if (['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'].includes(extension))
    return 'image';

  return 'unknown';
};
